<main class="mat-body">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 text-center mt-5 pt-md-5 mb-3">
                <h1 class="mat-display-3 text-white text-uppercase mb-4">{{ 'contract.landing.become-customer'|translate }}</h1>
                <p class="mat-headline text-white">{{ 'contract.landing.first-step'|translate }}</p>
            </div>
            <div class="col-11 col-sm-12 col-lg-9 p-4 p-md-5 mb-5 white-box">
                <p class="mb-4" [innerHTML]="'contract.landing.less-than-10-minutes'|translate"></p>
                <p class="mb-4 font-weight-bold">{{ 'contract.landing.you-will-need'|translate }}</p>
                <ul class="mb-3">
                    <li>{{ 'contract.landing.identification-document'|translate }}</li>
                    <li>{{ 'contract.landing.bank-account-receipt'|translate }}</li>
                    <li>{{ 'contract.landing.internet-connection'|translate }}</li>
                </ul>

                <div class="text-center">
                    <button class="px-5" type="button" mat-raised-button color="blue-ligth" (click)="onClick()">
                        {{ 'contract.landing.start'|translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</main>
